/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Security_Passkey_PlaceholderInputs */



/**
* | output |
* | --- |
* | "MacBook Pro" |
*
* @param {Partner_Security_Passkey_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_security_passkey_placeholder = /** @type {((inputs?: Partner_Security_Passkey_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Security_Passkey_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("MacBook Pro")
	return /** @type {LocalizedString} */ ("MacBook Pro")
});